import ReactDOM from 'react-dom/client';

import AppContainer from '@/AppContainer';
import { loadRuntimeConfig } from '@/config';
import './index.css';

loadRuntimeConfig().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(<AppContainer />);
});
